import StarRoundedIcon from "@mui/icons-material/StarRounded";
import { Box, Rating, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import useColors from "../../api/hooks/useColors";
import RedAsterisk from "../../components/RedAsterisk";

const TenantRatingField = () => {
  const colors = useColors();
  const { values, setFieldValue, errors, touched } = useFormikContext();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Box sx={{ display: "flex", gap: "2px", alignItems: "center" }}>
        <Typography variant="caption">Set tenant importance</Typography>
        <RedAsterisk />
      </Box>
      <Rating
        name="importance"
        value={values.importance}
        onChange={(_, newValue) => setFieldValue("importance", newValue)}
        icon={
          <StarRoundedIcon
            fontSize="inherit"
            style={{ color: colors.rating_checked_enabled }}
          />
        }
        emptyIcon={
          <StarRoundedIcon
            fontSize="inherit"
            style={{ color: colors.rating_unchecked_enabled }}
          />
        }
      />

      {/* Error message  */}
      {errors.importance &&
        touched.importance &&
        typeof errors.importance === "string" && (
          <Typography variant="caption" sx={{ color: colors.error_500 }}>
            {errors.importance}
          </Typography>
        )}
    </Box>
  );
};

export default TenantRatingField;
